import { doc, getDoc } from "firebase/firestore";
import { IPersona } from "../utils/types";
import { db } from "../firebase";

export const updatePersonas = async (personas: IPersona[], uid: string) => {
    const userRef = doc(db, "users", uid || "");
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();
    const personaId = userData?.personaId;

    const selectedFirstLevelIds = [];
    const selectedSecondLevelIds = [];

    if (personaId) {
        const personaRef = doc(db, "personas", personaId || "");
        const personaSnap = await getDoc(personaRef);
        const personaData = personaSnap.data();

        for (let i = 0; i < personas.length; i++) {
            const persona = personas[i];
            const selected = [];

            for (let j = 0; j < persona.categories.length; j++) {
                const category = persona.categories[j];
    
                if (personaData?.children.includes(category.name)) {
                    category.isSelected = true;
                    selected.push(category.id);
                }
            };

            if (personaData?.personas.includes(persona.name)) {
                persona.isSelected = true;
                selectedFirstLevelIds.push(persona.id);
                selectedSecondLevelIds.push({
                    personaId: persona.id,
                    childrenPersonaIds: selected,
                });
            };
        }
    }

    return {
        updatedPersonas: personas,
        updatedFirstLevelIds: selectedFirstLevelIds,
        updatedSecondLevelIds: selectedSecondLevelIds
    };
}